import { HttpStatus } from "../constants";
/**
 * ### Usages
 * ```tsx
 *  const response = await fetchWithTimeout( url, { headers: *some headers*}, 5000)
 * ```
 * @param url:  string
 * @param options: fetch options (headers, method, etc)
 * @param timeout: number (default 10000ms)
 */
export const fetchWithTimeout = (url, options, timeout = 10000
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) => Promise.race([
    fetch(url, options),
    new Promise((resolve) => setTimeout(() => {
        resolve({ error: HttpStatus.TIMEOUT, statusText: "TIMEOUT" });
    }, timeout)),
]);
